import { defineStore, storeToRefs } from "pinia";
import { socket } from '@/user.socket';
import { socket as feedsocket } from "@/feed.socket";
import { useResponseMessageStore } from "./response_message";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "./auth";
import { useFixturesStore } from "./fixtures";

export const useBetslipStore = defineStore('betslip', {
    state: () => ({
        slips: {},
        oddType: 'p',
        changes: false,
        updates: false,
        confirming: false,
        ticketId: null,
        sendingTicket: false,
    }),

    getters: {
        getSendingTicket: state => state.sendingTicket,
        hasChanges: state => state.changes,
        hasUpdates: state => state.updates,
        getOddType: state => state.oddType,
        getSlips: state => state.slips,
        isHighlited: state => uid => {
            for (let eid in state.slips) {
                if (uid in state.slips[eid].betslips) {
                    return true
                }
            }
            return false
        },
        isEventSelected: state => eid => eid in state.slips,
        cols(state) {
            let counter = 1
            for (let eid in state.slips) {
                counter *= Object.keys(state.slips[eid].betslips).length
            }
            return counter
        },
        selections(state) {
            let counter = 0
            for (let eid in state.slips) {
                counter += Object.keys(state.slips[eid].betslips).length
            }

            return counter
        },
        totalOdd(state) {
            let odd = 1;
            for (let eid in state.slips) {
                for (let uid in state.slips[eid].betslips) {
                    odd *= state.slips[eid].betslips[uid].p
                }
            }
            return odd
        },

        minAndMax: state => {
            let mins = []
            let maxs = []

            for (let eid in state.slips) {
                let min = 9999999
                let max = 1
                for (let uid in state.slips[eid].betslips) {
                    if (state.slips[eid].betslips[uid].p < min) min = state.slips[eid].betslips[uid].p
                    if (state.slips[eid].betslips[uid].p > max) max = state.slips[eid].betslips[uid].p
                }

                maxs.push(max)
                mins.push(min)
            }

            return [
                mins.reduce((acc, number) => acc * number, 1),
                maxs.reduce((acc, number) => acc * number, 1)
            ]
        },

        bonusValue(state){
           const auth = useAuthStore()
            const { getUser } = storeToRefs(auth)
            let bonusPerc
            if(this.selections && getUser.value?.tb ){
                if(getUser.value?.tb[this.selections] ){
                    bonusPerc = getUser.value?.tb[this.selections] 
                }
            }
            return bonusPerc
        }
    },

    actions: {
        setOddType (type) {
            this.oddType = type
            localStorage.setItem('oddType', type)
        },

        initializeFromLocalStorage() {
            let t = localStorage.getItem('ticket')
            const ticketIdAtReload = localStorage.getItem('ticketIdAtReload')
            if (t) {
                this.slips = JSON.parse(t)
            }

            if (ticketIdAtReload) {
                this.ticketId = ticketIdAtReload
            }
        },

        setOdd(odd, eid, mi , mnrs) {
            if (odd.st === 2 || odd.st === 3) return;

            if (!(eid in this.slips)) {
                this.slips[eid] = { betslips: {} }  
            }

            if (!(odd.i in this.slips[eid].betslips)) {
                const copy = JSON.parse(JSON.stringify(odd))
                copy.mi = mi  
                copy.mnrs = mnrs 
                this.slips[eid].betslips[odd.i] = copy
            } else {
                delete this.slips[eid].betslips[odd.i]

                if (!Object.keys(this.slips[eid].betslips).length) {
                    delete this.slips[eid]
                }
            }

            localStorage.setItem('ticket', JSON.stringify(this.slips))
        },
        updateOdd(eid, odd) {
            if (this.confirming) return;
            if (this.updateKoef(eid, odd)) {
                this.updates = true
            }
            localStorage.setItem('ticket', JSON.stringify(this.slips))
        },

        updateKoef(eid, odd) {
            if (!this.changes) {
                if (eid in this.slips) {
                    if (odd.i in this.slips[eid].betslips) {
                        this.slips[eid].betslips[odd.i] = odd
                        return true
                    }
                }
            }
            return false
        },

        acceptUpdates() {
            this.updates = false
          
        },

        pullSlip(eid) {
            if (eid in this.slips) {
                delete this.slips[eid]
            }

            localStorage.setItem('ticket', JSON.stringify(this.slips))
        },

        send(cur_id, amount, childId = null) {
            if (this.changes) {
                this.acceptChanges()
                return;
            }

            try {
                this.sendingTicket = true
                const fixtures = useFixturesStore()
                const { getEvent } = storeToRefs(fixtures)

                for (let event in this.slips) {
                    let e;
                    e = JSON.parse(JSON.stringify(getEvent.value(event)))
                    this.slips[e.i] = {...this.slips[e.i], ...e}
                }
                const ticketData = {
                    cur_id,
                    amount: Number(amount),
                    ticket: this.slips,
                }
        
                if (childId) {
                    ticketData.childId = childId
                }
                socket.emit('ticket:create', ticketData)
            } catch (error) {
                this.sendingTicket = false
                console.error(error.message)
            }
        },

        clear() {
            this.sendingTicket = false
            this.slips = {}
            this.confirming = false
            localStorage.setItem('ticket', '')
        },

        acceptChanges() {
            if (!this.ticketId) return;

            socket.emit('ticket:accept-offer', {ticketId: this.ticketId})
            this.changes = false
            this.ticketId = null
            localStorage.removeItem('ticketIdAtReload')

            this.clear()
        },

        rejectChanges() {
            if (!this.ticketId) return;

            socket.emit('ticket:refuse-offer', {ticketId: this.ticketId})

            this.changes = false
            this.sendingTicket = false
            this.ticketId = null
            localStorage.removeItem('ticketIdAtReload')

        },

        bindSocketEvents() {
            const responseMessageStore = useResponseMessageStore()
            const { t } = useI18n()

            socket.on('ticket:create', (data) => {
                if (data.ok) {
                    responseMessageStore.setMessage(t('betslips.created'))
                    const pathParts = window.location.pathname.split('/');
                    const eidFromUrl = pathParts.includes('in-play') ? pathParts[pathParts.indexOf('in-play') + 1] : null;
                    for (let event in this.slips) {
                        if (event !== eidFromUrl) {
                            feedsocket.emit('leave-fixture-odds', {i: event})  
                        }
                    }
                    this.clear()
                } else {
                    console.log('no')
                    this.sendingTicket = false
                    this.confirming = false
                    responseMessageStore.setMessage(t(data.message, {extra: data.extra}))
                }
            })
            socket.on('ticket:confirming', (data) => {
                if (data.ok) {
                    this.confirming = true
                    responseMessageStore.setMessage(t(data.message, {extra: data.extra}))
                }
            })

            socket.on('ticket:offer', (data) => { 
                if (data.ok) {
                    responseMessageStore.setMessage(t(data.message, {extra: data.extra}))

                    for (let eid in data.data.s) {
                        for (let uid in data.data.s[eid]) {
                            if (this.slips[eid].betslips[uid].p > data.data.s[eid][uid]) {
                                this.slips[eid].betslips[uid].n = 1
                            } else {
                                this.slips[eid].betslips[uid].n = 2
                            }

                            this.slips[eid].betslips[uid].p = data.data.s[eid][uid]

                            this.changes = true
                            this.sendingTicket = false
                        }
                    }
                    this.ticketId = data.data._id
                    localStorage.setItem('ticket', JSON.stringify(this.slips))
                    localStorage.setItem('ticketIdAtReload', this.ticketId)
                }
            })

            socket.on('ticket:accept-offer', (data) => {
                if (data.ok) {
                    responseMessageStore.setMessage(t('betslips.created'))
                }
            })
        }
    }
})